module.exports = __webpack_public_path__ + "img/position_SS.ffe10839.png";